function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _BaseMenuItem from "@tydic-group/component-base/src/components/base-menu-item";
import _BaseSubmenu from "@tydic-group/component-base/src/components/base-submenu";
import _BaseMenuGroup from "@tydic-group/component-base/src/components/base-menu-group";
import _BaseTransfer from "@tydic-group/component-base/src/components/base-transfer";
import _BaseTable from "@tydic-group/component-base/src/components/base-table";
import _BaseTitle from "@tydic-group/component-base/src/components/base-title";
import _BaseScroll from "@tydic-group/component-base/src/components/base-scroll";
import _BaseDivider from "@tydic-group/component-base/src/components/base-divider";
import _BaseBackTop from "@tydic-group/component-base/src/components/base-back-top";
import _BaseSpin from "@tydic-group/component-base/src/components/base-spin";
import _BaseProgress from "@tydic-group/component-base/src/components/base-progress";
import _BasePoptip from "@tydic-group/component-base/src/components/base-poptip";
import _BaseNotice from "@tydic-group/component-base/src/components/base-notice";
import _BaseModal from "@tydic-group/component-base/src/components/base-modal";
import _BaseMessage from "@tydic-group/component-base/src/components/base-message";
import _BaseLoadingBar from "@tydic-group/component-base/src/components/base-loading-bar";
import _BaseDrawer from "@tydic-group/component-base/src/components/base-drawer";
import _BaseAlert from "@tydic-group/component-base/src/components/base-alert";
import _BaseTree from "@tydic-group/component-base/src/components/base-tree";
import _BaseTooltip from "@tydic-group/component-base/src/components/base-tooltip";
import _BaseTimelineItem from "@tydic-group/component-base/src/components/base-timeline-item";
import _BaseTimeline from "@tydic-group/component-base/src/components/base-timeline";
import _BaseTabPane from "@tydic-group/component-base/src/components/base-tab-pane";
import _BaseTag from "@tydic-group/component-base/src/components/base-tag";
import _BaseTabs from "@tydic-group/component-base/src/components/base-tabs";
import _BaseList from "@tydic-group/component-base/src/components/base-list";
import _BaseCollapse from "@tydic-group/component-base/src/components/base-collapse";
import _BaseCarouselItem from "@tydic-group/component-base/src/components/base-carousel-item";
import _BaseCarousel from "@tydic-group/component-base/src/components/base-carousel";
import _BaseCard from "@tydic-group/component-base/src/components/base-card";
import _BaseBadge from "@tydic-group/component-base/src/components/base-badge";
import _BaseAvatar from "@tydic-group/component-base/src/components/base-avatar";
import _BaseUpload from "@tydic-group/component-base/src/components/base-upload";
import _BaseTimePicker from "@tydic-group/component-base/src/components/base-time-picker";
import _BaseSwitch from "@tydic-group/component-base/src/components/base-switch";
import _BaseSlider from "@tydic-group/component-base/src/components/base-slider";
import _BaseSelect from "@tydic-group/component-base/src/components/base-select";
import _BaseRate from "@tydic-group/component-base/src/components/base-rate";
import _BaseCheckboxGroup from "@tydic-group/component-base/src/components/base-checkbox-group";
import _BaseRadioGroup from "@tydic-group/component-base/src/components/base-radio-group";
import _BaseRadio from "@tydic-group/component-base/src/components/base-radio";
import _BaseInputNumber from "@tydic-group/component-base/src/components/base-input-number";
import _BaseInput from "@tydic-group/component-base/src/components/base-input";
import _BaseFormItem from "@tydic-group/component-base/src/components/base-form-item";
import _BaseForm from "@tydic-group/component-base/src/components/base-form";
import _BaseDatePicker from "@tydic-group/component-base/src/components/base-date-picker";
import _BaseCheckbox from "@tydic-group/component-base/src/components/base-checkbox";
import _BaseCascader from "@tydic-group/component-base/src/components/base-cascader";
import _BaseSteps from "@tydic-group/component-base/src/components/base-steps";
import _BaseStep from "@tydic-group/component-base/src/components/base-step";
import _BasePage from "@tydic-group/component-base/src/components/base-page";
import _BaseMenu from "@tydic-group/component-base/src/components/base-menu";
import _BaseDropdownItem from "@tydic-group/component-base/src/components/base-dropdown-item";
import _BaseDropdownMenu from "@tydic-group/component-base/src/components/base-dropdown-menu";
import _BaseDropdown from "@tydic-group/component-base/src/components/base-dropdown";
import _BaseBreadcrumbItem from "@tydic-group/component-base/src/components/base-breadcrumb-item";
import _BaseBreadcrumb from "@tydic-group/component-base/src/components/base-breadcrumb";
import _BaseAnchorLink from "@tydic-group/component-base/src/components/base-anchor-link";
import _BaseAnchor from "@tydic-group/component-base/src/components/base-anchor";
import _BaseAffix from "@tydic-group/component-base/src/components/base-affix";
import _BaseOption from "@tydic-group/component-base/src/components/base-option";
import _BaseCol from "@tydic-group/component-base/src/components/base-col";
import _BaseRow from "@tydic-group/component-base/src/components/base-row";
import _BaseIcon from "@tydic-group/component-base/src/components/base-icon";
import _BaseButton from "@tydic-group/component-base/src/components/base-button";
import "core-js/modules/es6.array.copy-within";
import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.array.of";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.species";
import "core-js/modules/es6.date.to-primitive";
import "core-js/modules/es6.function.has-instance";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.map";
import "core-js/modules/es6.math.acosh";
import "core-js/modules/es6.math.asinh";
import "core-js/modules/es6.math.atanh";
import "core-js/modules/es6.math.cbrt";
import "core-js/modules/es6.math.clz32";
import "core-js/modules/es6.math.cosh";
import "core-js/modules/es6.math.expm1";
import "core-js/modules/es6.math.fround";
import "core-js/modules/es6.math.hypot";
import "core-js/modules/es6.math.imul";
import "core-js/modules/es6.math.log1p";
import "core-js/modules/es6.math.log10";
import "core-js/modules/es6.math.log2";
import "core-js/modules/es6.math.sign";
import "core-js/modules/es6.math.sinh";
import "core-js/modules/es6.math.tanh";
import "core-js/modules/es6.math.trunc";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.epsilon";
import "core-js/modules/es6.number.is-finite";
import "core-js/modules/es6.number.is-integer";
import "core-js/modules/es6.number.is-nan";
import "core-js/modules/es6.number.is-safe-integer";
import "core-js/modules/es6.number.max-safe-integer";
import "core-js/modules/es6.number.min-safe-integer";
import "core-js/modules/es6.number.parse-float";
import "core-js/modules/es6.number.parse-int";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.object.define-getter";
import "core-js/modules/es7.object.define-setter";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.object.get-own-property-descriptor";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.get-own-property-names";
import "core-js/modules/es6.object.get-prototype-of";
import "core-js/modules/es7.object.lookup-getter";
import "core-js/modules/es7.object.lookup-setter";
import "core-js/modules/es6.object.prevent-extensions";
import "core-js/modules/es6.object.is";
import "core-js/modules/es6.object.is-frozen";
import "core-js/modules/es6.object.is-sealed";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.seal";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.reflect.apply";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.reflect.define-property";
import "core-js/modules/es6.reflect.delete-property";
import "core-js/modules/es6.reflect.get";
import "core-js/modules/es6.reflect.get-own-property-descriptor";
import "core-js/modules/es6.reflect.get-prototype-of";
import "core-js/modules/es6.reflect.has";
import "core-js/modules/es6.reflect.is-extensible";
import "core-js/modules/es6.reflect.own-keys";
import "core-js/modules/es6.reflect.prevent-extensions";
import "core-js/modules/es6.reflect.set";
import "core-js/modules/es6.reflect.set-prototype-of";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.flags";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.set";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.string.anchor";
import "core-js/modules/es6.string.big";
import "core-js/modules/es6.string.blink";
import "core-js/modules/es6.string.bold";
import "core-js/modules/es6.string.code-point-at";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.string.fixed";
import "core-js/modules/es6.string.fontcolor";
import "core-js/modules/es6.string.fontsize";
import "core-js/modules/es6.string.from-code-point";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.italics";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.string.link";
import "core-js/modules/es7.string.pad-start";
import "core-js/modules/es7.string.pad-end";
import "core-js/modules/es6.string.raw";
import "core-js/modules/es6.string.repeat";
import "core-js/modules/es6.string.small";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.string.strike";
import "core-js/modules/es6.string.sub";
import "core-js/modules/es6.string.sup";
import "core-js/modules/es6.typed.array-buffer";
import "core-js/modules/es6.typed.int8-array";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.typed.uint8-clamped-array";
import "core-js/modules/es6.typed.int16-array";
import "core-js/modules/es6.typed.uint16-array";
import "core-js/modules/es6.typed.int32-array";
import "core-js/modules/es6.typed.uint32-array";
import "core-js/modules/es6.typed.float32-array";
import "core-js/modules/es6.typed.float64-array";
import "core-js/modules/es6.weak-map";
import "core-js/modules/es6.weak-set";
import "core-js/modules/web.timers";
import "core-js/modules/web.immediate";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import Vue from 'vue';
import App from './App';
import './icons'; // SVG
// 配置
// 混合

import mixinApp from '@/mixins/app'; // 字体

import '@/assets/font/font.css'; // 插件

import plugins from '@/plugins';
import lodash from 'lodash';
import moment from 'moment';
import accounting from 'accounting';
import axios from 'axios'; // 过滤器

import filters from '@/plugins/filter'; // store

import store from '@/store/index'; // 懒加载

import VueLazyload from 'vue-lazyload'; // iView 和 iView Pro

import ViewUI from 'view-design';
import iViewPro from '@/libs/iview-pro/iview-pro.min.js';
import shop from '@tydic-group/shop-components';
import '@tydic-group/shop-components/dist/themes/default/index.less'; // 按需引入 逐步替换

import 'xe-utils';
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css'; // 菜单和路由

import router from './router'; // 导入 icon-select

import iIconSelect from '@/libs/icon-select/icon-select.min';
import { frameInRoutes } from '@/router/routes'; // 多语言

import _i18n from '@/i18n'; // 方法

import { getMenuCrumbs } from '@/libs/system'; // 全局工具

import CONSTANT from '@/api/constant';
import DYC_URL from '@/api/url/index';
import util from '@/libs/util';
import cascadeOfCity from '@/components/common/cascadeOfCityCopy'; // 虚拟表格插件

import vxeTable from 'vxe-table';
import 'vxe-table/lib/style.css'; // 内置组件

import iLink from '@/components/link';
import iFrame from '@/components/frame'; // 使用样式，修改主题可以在 styles 目录下创建新的主题包并修改 iView 默认的 less 变量
// 参考 https://www.iviewui.com/docs/guide/theme

import './libs/iview-pro/iview-pro.css';
import './styles/index.less';
import './libs/icon-select/icon-select.css';
import { mapState } from 'vuex';

function cacheClear() {
  return _cacheClear.apply(this, arguments);
}

function _cacheClear() {
  _cacheClear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var buildVer, locBuildVer, hostWhiteList, whiteList, isWhiteList, key, _key;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            buildVer = process.env.BUILD_VERSION;
            locBuildVer = localStorage.getItem('buildVer'); // 白名单

            hostWhiteList = ['liando.cn'];
            whiteList = ['userData', 'auth-token']; // 是否属于域名白名单

            isWhiteList = hostWhiteList.some(function (item) {
              return window.location.host.includes(item) && !window.location.host.includes("test");
            }); // 如果最后编译版本和当前编译版本不同，清理缓存

            if (isWhiteList || Object.is(buildVer, locBuildVer)) {
              _context.next = 24;
              break;
            }

            console.log('新版本更新'); // 清理localStorage

            _context.t0 = _regeneratorRuntime().keys(localStorage);

          case 8:
            if ((_context.t1 = _context.t0()).done) {
              _context.next = 15;
              break;
            }

            key = _context.t1.value;

            if (!whiteList.includes(key)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("continue", 8);

          case 12:
            localStorage.removeItem(key);
            _context.next = 8;
            break;

          case 15:
            _context.t2 = _regeneratorRuntime().keys(sessionStorage);

          case 16:
            if ((_context.t3 = _context.t2()).done) {
              _context.next = 23;
              break;
            }

            _key = _context.t3.value;

            if (!whiteList.includes(_key)) {
              _context.next = 20;
              break;
            }

            return _context.abrupt("continue", 16);

          case 20:
            sessionStorage.removeItem(_key);
            _context.next = 16;
            break;

          case 23:
            localStorage.setItem('buildVer', buildVer);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _cacheClear.apply(this, arguments);
}

cacheClear();
armsSetEnv();

function armsSetEnv() {
  try {
    if (window.__bl) {
      var mapper = {
        development: 'local',
        production: 'prod',
        test: 'daily',
        uat: "pre"
      };
      var env = mapper[process.env.NODE_ENV];
      var prodHost = ["lsugu.com", "/lsugu.liando.cn"];

      if (env === "pre" && prodHost.some(function (host) {
        return window.location.href.includes(host);
      })) {
        env = "prod";
      }

      if (!window.__bl.setConfig) {
        if (window.__bl.config) {
          window.__bl.config.environment = env;
        }
      } else {
        window.__bl.setConfig({
          environment: env
        });
      }
    }
  } catch (err) {
    console.log(err);
  }
}

function themeConfig(mode) {
  if (mode === 'skyBlue') {
    return import('./styles/themeSkyBlue.less');
  } else if (mode === 'darkBlue') {
    return import('./styles/themeDarkBlue.less');
  } else if (mode === 'orange') {
    return import('./styles/themeOrange.less');
  } else if (mode === 'red') {
    return import('./styles/themeRed.less');
  } else if (mode === 'green') {
    return import('./styles/themeGreen.less');
  }

  return import('./styles/themeSkyBlue.less');
}

themeConfig(localStorage.getItem('theme')); // 注释的组件都是没引进的

Vue.use(VXETable);
Vue.use(_BaseButton);
Vue.use(_BaseIcon);
Vue.use(_BaseRow);
Vue.use(_BaseCol); // Vue.use(BaseGrid);

Vue.use(_BaseOption); // Vue.use(BaseLayout);
// Vue.use(BaseSplit);

Vue.use(_BaseAffix);
Vue.use(_BaseAnchor);
Vue.use(_BaseAnchorLink);
Vue.use(_BaseBreadcrumb);
Vue.use(_BaseBreadcrumbItem);
Vue.use(_BaseDropdown);
Vue.use(_BaseDropdownMenu);
Vue.use(_BaseDropdownItem);
Vue.use(_BaseMenu);
Vue.use(_BasePage); // Vue.use(BasePageHeader);

Vue.use(_BaseStep);
Vue.use(_BaseSteps);
Vue.use(_BaseCascader);
Vue.use(_BaseCheckbox);
Vue.use(_BaseDatePicker);
Vue.use(_BaseForm);
Vue.use(_BaseFormItem);
Vue.use(_BaseInput);
Vue.use(_BaseInputNumber);
Vue.use(_BaseRadio);
Vue.use(_BaseRadioGroup);
Vue.use(_BaseCheckboxGroup);
Vue.use(_BaseRate);
Vue.use(_BaseSelect);
Vue.use(_BaseSlider);
Vue.use(_BaseSwitch);
Vue.use(_BaseTimePicker); // Vue.use(BaseTransfe);

Vue.use(_BaseUpload);
Vue.use(_BaseAvatar);
Vue.use(_BaseBadge);
Vue.use(_BaseCard);
Vue.use(_BaseCarousel);
Vue.use(_BaseCarouselItem);
Vue.use(_BaseCollapse); // Vue.use(BaseCopyright);
// Vue.use(BaseDescriptions);
// Vue.use(BaseEmpty);

Vue.use(_BaseList); // Vue.use(BaseStatistic);

Vue.use(_BaseTabs);
Vue.use(_BaseTag);
Vue.use(_BaseTabPane);
Vue.use(_BaseTimeline);
Vue.use(_BaseTimelineItem);
Vue.use(_BaseTooltip);
Vue.use(_BaseTree);
Vue.use(_BaseAlert);
Vue.use(_BaseDrawer); // Vue.use(BaseGuideDistribution);
// Vue.use(BaseGuideFullScreen);
// Vue.use(BaseGuideStep);

Vue.use(_BaseLoadingBar);
Vue.use(_BaseMessage);
Vue.use(_BaseModal);
Vue.use(_BaseNotice);
Vue.use(_BasePoptip);
Vue.use(_BaseProgress);
Vue.use(_BaseSpin);
Vue.use(_BaseBackTop);
Vue.use(_BaseDivider);
Vue.use(_BaseScroll); // Vue.use(BaseDisplay);
// Vue.use(BaseStatusTip);

Vue.use(_BaseTitle);
Vue.use(_BaseTable);
Vue.use(_BaseTransfer);
Vue.use(_BaseMenuGroup);
Vue.use(_BaseSubmenu);
Vue.use(_BaseMenuItem);
Vue.use(shop);
Vue.use(iIconSelect);
Vue.use(vxeTable);
Vue.use(VueLazyload, {
  error: require('@/assets/images/lost2.png')
});
Vue.component('addressChoice', cascadeOfCity);
Vue.prototype.$accounting = accounting;
Vue.prototype.$tool = util.tool; // 智齿sysnum

Vue.prototype.$sysnum = 'c7ae4b7f6dba4507a0cadb4623fa0e3e';
if (window) window.$t = function (key, value) {
  return _i18n.t(key, value);
};
Vue.use(plugins);
Vue.use(ViewUI, {
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
});
window.CONSTANT = CONSTANT;
window.DYC_URL = DYC_URL;
window.util = util;
window.accounting = accounting;
window._ = lodash;
window.moment = moment;
window.axios = axios;
console.log(process.env.NODE_ENV, 'process.env.NODE_ENV');

Vue.config.warnHandler = function (err, vm, info) {// console.log(info)
};

if (process.env.NODE_ENV !== 'development') {
  console.log = function () {};
}

_.each(filters, function (val, key) {
  Vue.filter(key, val);
});

Vue.use(iViewPro);
Vue.component('i-link', iLink);
Vue.component('i-frame', iFrame);
Vue.component('treeselect', Treeselect);
new Vue({
  mixins: [mixinApp],
  router: router,
  store: store,
  i18n: _i18n,
  render: function render(h) {
    return h(App);
  },
  created: function created() {
    // 处理路由 得到每一级的路由设置;
    this.$store.commit('admin/page.ht/init', frameInRoutes); // 加载用户登录的数据

    this.$store.dispatch('admin/account/load'); // 初始化全屏监听

    this.$store.dispatch('admin/layout.ht/listenFullscreen');
  },
  computed: _objectSpread({}, mapState('admin/menu.ht', ['menu'])),
  watch: {
    // 监听路由 控制侧边栏显示 标记当前顶栏菜单（如需要）
    '$route': function $route(to, from) {
      var path = to.matched[to.matched.length - 1].name === 'iframe' ? to.path : to.matched[to.matched.length - 1].path; // let menuData = this.$store.getters['admin/menu.ht/getMenu'];
      // let menuData = this.menu;

      var menuData = this.menu.length > 0 ? this.menu : JSON.parse(sessionStorage.getItem('menuList'));
      var currentMenuCrumbs = getMenuCrumbs(path, menuData);

      if (currentMenuCrumbs) {
        // 404 等门户页面 currentMenuCrumbs为null
        this.$store.commit('admin/menu.ht/setCurrentMenuCrumbs', currentMenuCrumbs);
      }

      this.appRouteChange(to, from);
    },
    'menu': function menu() {
      var path = this.$route.path;
      var menuData = this.menu;
      var currentMenuCrumbs = getMenuCrumbs(path, menuData);

      if (currentMenuCrumbs) {
        // 404 等门户页面 currentMenuCrumbs为null
        this.$store.commit('admin/menu.ht/setCurrentMenuCrumbs', currentMenuCrumbs);
      }
    }
  }
}).$mount('#app');